(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-usps"] && !Shopify.designMode) return;
  try {
    
  // Vereist: jQuery + Owl Carousel JS geladen in theme
  (function() {
    var initUspCarousel = function() {
      var $carousel = $('.js-usp-carousel');

      if (!$carousel.length || $carousel.hasClass('owl-loaded')) return;

      $carousel.owlCarousel({
        loop: false,
        margin: 0,
        nav: false,
        
        dots: false,
        responsive: {
          0: {
            items: 1,
            mouseDrag: false,
            touchDrag: false,
            autoplay:true,
            autoplayTimeout:3000,
            autoplayHoverPause:true
          },
          600: {
            items: 2,
            mouseDrag: false,
            touchDrag: false,
            autoplay:true,
            autoplayTimeout:3000,
            autoplayHoverPause:true
          },
          1025: {
            items: 4,
            dots: false,
            mouseDrag: false,
            touchDrag: false
          }
        }
      });
    };

    if (window.jQuery && $.fn.owlCarousel) {
      initUspCarousel();
    } else {
      document.addEventListener('DOMContentLoaded', initUspCarousel);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
